export default __webpack_public_path__ + "static/media/figma.25abb591.svg";